import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

function toSnakeSortId(id) {
  return String(id).replace(/[A-Z]/g, (char) => `_${char.toLowerCase()}`);
}

// 後端 sort 欄位為 snake（`sort=sort_key,asc`）；表頭 column id 為 camel
export async function fetchMtrList(listQuery) {
  const { data: raw } = await request.get('/mtr', {
    params: listQueryToApiParams({
      ...listQuery,
      sort: (listQuery?.sort ?? []).map((item) => ({ ...item, id: toSnakeSortId(item.id) })),
    }),
  });
  return parseVer4ListResponse(raw);
}
